import { Typography } from '@mui/material'

export const SectionHeader = ({ children }: { children: React.ReactNode }) => (
    <Typography
        variant="h1"
        sx={{
            fontSize: '28px',
            fontWeight: 600,
            lineHeight: '36px',
            margin: '20px 0',
        }}
    >
        {children}
    </Typography>
)
